import i18n from './i18n'
import router from './router'
import store from './store'
import Vue from 'vue'
import 'bootstrap'
import moment from 'moment'
import VModal from 'vue-js-modal'
import Clipboard from 'v-clipboard'
import VueSweetalert2 from 'vue-sweetalert2'
import VueNumeric from 'vue-numeric'
import uploader from 'vue-simple-uploader'
import VueCurrencyInput from 'vue-currency-input'
import VueProgressBar from 'vue-progressbar'
import VueGtag from "vue-gtag";
import App from './App'

Vue.config.productionTip = false

Vue.filter('formatDateTime', function (value) {
  if (value) {
    return moment(String(value)).format('DD.MM.YYYY HH:mm')
  }
})

Vue.filter('formatDate', function (value) {
  if (value) {
    return moment(String(value)).format('DD.MM.YYYY')
  }
})

Vue.filter('translateUnitOrDefault', function (value) {
  if(value) {
    return i18n.t(`units.${value}`)
  }
  return value
})

Vue.use(VModal)
Vue.use(Clipboard)
Vue.use(VueSweetalert2)
Vue.use(VueNumeric)
Vue.use(uploader)
Vue.use(VueCurrencyInput, {
  globalOptions: {
    currency: "EUR",
    distractionFree: true,
    precision: 2,
    allowNegative: false
  }
})

Vue.use(VueProgressBar, {
  color: '#ff7109',
  failedColor: '#874b4b',
  thickness: '3px',
  transition: {
    speed: '0.2s',
    opacity: '0.6s',
    termination: 200
  },
  autoRevert: true,
  autoFinish: true,
  location: 'top',
  inverse: false
})

import VueNestable from 'vue-nestable'
Vue.use(VueNestable)

if (process.env.GA_TRACKING_ID) {
  Vue.use(VueGtag, {
    config: { id: process.env.GA_TRACKING_ID }
  }, router);
}

export default new Vue({
  router,
  store,
  i18n,
  render: h => h(App)
}).$mount('#app')



// WEBPACK FOOTER //
// ./src/main.js